import { render, staticRenderFns } from "./AllocationSidebar.vue?vue&type=template&id=5bd590e0&scoped=true"
import script from "./AllocationSidebar.vue?vue&type=script&lang=js"
export * from "./AllocationSidebar.vue?vue&type=script&lang=js"
import style0 from "./AllocationSidebar.vue?vue&type=style&index=0&id=5bd590e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd590e0",
  null
  
)

export default component.exports